import { ReactNode } from 'react';
import { AuthProvider } from 'react-oidc-context';

import { useSSOAuthContext } from './SSOAuthProvider';

interface DynamicOIDCProviderProps {
  children: ReactNode;
}

export function DynamicOIDCProvider({ children }: DynamicOIDCProviderProps) {
  const { cognitoConfig } = useSSOAuthContext();

  // Only render AuthProvider when we have dynamic configuration
  if (!cognitoConfig) {
    return <>{children}</>;
  }

  return <AuthProvider {...cognitoConfig}>{children}</AuthProvider>;
}
